import React, { Component } from 'react';
import { connect } from 'react-redux';
import { OnboardingPage } from '../../../ui';
import Personal from './CompleteProfile/Personal';


const mapStateToProps = (state) => {
  return {
    device: state.resolution.device,
  };
};

class CompleteProfile extends Component<any> {
  render() {

    const isMobile = this.props.device === 'mobile' || this.props.device === 'mobile-tablet';

    return (
      <OnboardingPage isMobile={isMobile}>
        <Personal />
      </OnboardingPage>
    );
  }
}

export default connect(mapStateToProps, null)(CompleteProfile);
